/*
 *  Content Container Scripts
 *    Scripts that are for the manipulation of the content container
 *
 *  Version:
 *    1.0.0 - 2020/03/02
 */

export const TEMPLATE_CONTAINER = '[data-content-container]';
export const CONTENT_CONTAINER = '[data-content]';

class ContentContainer {
  constructor(container) {
    //Elements
    this.container = container;
    this.contentContainer = container.find(CONTENT_CONTAINER);
   
    this.unwrapContentImages();
  }

  unwrapContentImages() {
    this.contentContainer.find('img').each((e,i) => {
      let current = $(i);
      // skip unwraop if it's a feature video
      while (!current.parent().is(this.contentContainer) 
      && !current.hasClass('c-article__video-image--img')
      && !current.hasClass('o-icon')) {
        console.log(current);
        current.unwrap();
      };
      
    });
  }
}

$(document).ready($(TEMPLATE_CONTAINER).each(
  (e,i) => new ContentContainer($(i))
));